// @ts-expect-error React import required to render in Jira SSR
import React from 'react';
import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--jira-werewolves/jira-for-you-crossflow-solutions';

import { JpdRecommendationBanner } from '../../../components/JpdRecommendationBanner';

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<PlacementRenderProps>(),
		Component: ({ dismiss }: PlacementRenderProps) => <JpdRecommendationBanner dismiss={dismiss} />,
	},
});
